import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import Button from '../components/Button';

export default function PageState({
  loading,
  error,
  onRetry,
  loadingMessage = 'Loading…',
  errorTitle = 'Something went wrong',
  children,
}) {
  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh" gap={2}>
        <CircularProgress />
        <Typography color="text.secondary">{loadingMessage}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh" gap={2} px={2}>
        <Typography variant="h6">{errorTitle}</Typography>
        {onRetry ? <Button onClick={onRetry}>Retry</Button> : null}
      </Box>
    );
  }

  return children;
}
